const ResourceConstants = {}

if (window.__ENV__ === 'PRODUCTION') {
  ResourceConstants.CUSTOMER_API = 'https://customer.api.drift.com'
  ResourceConstants.AUTH_API = 'https://api.drift.com/auth'
  ResourceConstants.BILLING_API = 'https://api.drift.com/billing'
  ResourceConstants.KONG_CUSTOMER_API = 'https://api.drift.com/customer'
  ResourceConstants.APP_ROOT = 'https://app.drift.com'
  ResourceConstants.SENTRY_KEY = 'https://e696fe8e874243d1a9c15e76dee5c6a6@app.getsentry.com/51073'
  ResourceConstants.CLIENT_ID = 'iVxHr9naeG4gMm'
  ResourceConstants.DEFAULT_CLIENT_ID = '1UDhLV0zBBVZo3'
  ResourceConstants.DEFAULT_REDIRECT_URL = 'https://app.drift.com'
  ResourceConstants.WHITELISTED_REDIRECT_SUBDOMAINS = ['admin.drift.com', 'dev.drift.com', 'app.drift.com', 'insider.drift.com', 'hyfy.auth0.com', 'bizops-admin-api.drift.com', 'video.drift.com']
  ResourceConstants.SEGMENT_ID = 'YXwH8WAoOobo2Fa0YwXM5a1Ag09H7LXX'
  ResourceConstants.GOOGLE_CLIENT_ID = '87492603950-u124kma19e32jh963uc9s3vsuujpm53k.apps.googleusercontent.com'
  ResourceConstants.MICROSOFT_CLIENT_ID = '57aa99b9-8cd2-4c0e-9498-2d6749d33f3b'
  ResourceConstants.LOGIN_ROOT = 'https://start.drift.com'
  ResourceConstants.CUSTOM_CLIENTS = {
    'dhh5gum2ftftx7': 'Drift Insider',
    'zvzrx8gv4kt347': 'Drift Video', 
    '4p2iyyu7m8swh6': 'Drift Video', //post Auth0 migration
    '57bbd3crm4rgg9': 'Bizops Admin'
  }
  ResourceConstants.DRIFT_VIDEO_CLIENT_ID = 'zvzrx8gv4kt347',
  ResourceConstants.DRIFT_VIDEO_CLIENT_ID_DRIFT = '4p2iyyu7m8swh6',
  ResourceConstants.DRIFT_VIDEO_URL = 'https://video.drift.com'
} else if (window.__ENV__ === 'MASTER') {
  ResourceConstants.CUSTOMER_API = 'https://customer2.api.driftqa.com'
  ResourceConstants.AUTH_API = 'https://api.driftqa.com/auth'
  ResourceConstants.KONG_CUSTOMER_API = 'https://api.driftqa.com/customer'
  ResourceConstants.BILLING_API = 'https://api.driftqa.com/billing'
  ResourceConstants.APP_ROOT = 'https://app.driftqa.com'
  ResourceConstants.SENTRY_KEY = 'https://e696fe8e874243d1a9c15e76dee5c6a6@app.getsentry.com/51073'
  ResourceConstants.CLIENT_ID = 'HcVEwgp9wDnDvd'
  ResourceConstants.DEFAULT_CLIENT_ID = 'W41NvthhICG4VC'
  ResourceConstants.DEFAULT_REDIRECT_URL = 'https://app.driftqa.com'
  ResourceConstants.WHITELISTED_REDIRECT_SUBDOMAINS = ['localhost', 'admin.driftqa.com', 'dev.driftqa.com', 'app.driftqa.com', 'insider.localhost', 'hyfy.auth0.com', 'bizops-admin-api.driftqa.com', 'app-qa.video.drift.com']
  ResourceConstants.SEGMENT_ID = '26F56Q24FYGhT79jXwkS3Ax002VxcoCN'
  ResourceConstants.GOOGLE_CLIENT_ID = '519208343067-nl6fp3es3cfqifpotab43kjqg7f85ssc.apps.googleusercontent.com'
  ResourceConstants.MICROSOFT_CLIENT_ID = '14eeaf85-cfbb-45c6-84fb-0541d2121f9b'
  ResourceConstants.LOGIN_ROOT = 'https://start.driftqa.com',
  ResourceConstants.CUSTOM_CLIENTS = {
    'z7a9zs6p7rzang': 'Drift Insider',
    '2s4izkwgch6v89': 'Drift Video',
    '7m4k8pi4v8be53': 'Drift Video', //post Auth0 migration
    'yxb9v9kgtkn6wk': 'Bizops Admin'
  },
  ResourceConstants.DRIFT_VIDEO_CLIENT_ID = '2s4izkwgch6v89',
  ResourceConstants.DRIFT_VIDEO_CLIENT_ID_DRIFT = '7m4k8pi4v8be53',
  ResourceConstants.DRIFT_VIDEO_URL = 'https://app-qa.video.drift.com'
} else {
  ResourceConstants.CUSTOMER_API = 'https://customer2.api.driftqa.com'
  ResourceConstants.AUTH_API = 'https://api.driftqa.com/auth'
  ResourceConstants.KONG_CUSTOMER_API = 'https://api.driftqa.com/customer'
  ResourceConstants.BILLING_API = 'https://api.driftqa.com/billing'
  ResourceConstants.APP_ROOT = 'https://app.driftqa.com'
  ResourceConstants.CLIENT_ID = 'HcVEwgp9wDnDvd'
  ResourceConstants.DEFAULT_CLIENT_ID = 'W41NvthhICG4VC'
  ResourceConstants.DEFAULT_REDIRECT_URL = 'https://app.driftqa.com'
  ResourceConstants.WHITELISTED_REDIRECT_SUBDOMAINS = ['localhost', 'admin.driftqa.com', 'dev.driftqa.com', 'app.driftqa.com', 'insider.localhost', 'hyfy.auth0.com', 'bizops-admin-api.driftqa.com', 'app-qa.video.drift.com', 'video.drift.com']
  ResourceConstants.SEGMENT_ID = '26F56Q24FYGhT79jXwkS3Ax002VxcoCN'
  ResourceConstants.GOOGLE_CLIENT_ID = '519208343067-nl6fp3es3cfqifpotab43kjqg7f85ssc.apps.googleusercontent.com'
  ResourceConstants.MICROSOFT_CLIENT_ID = '14eeaf85-cfbb-45c6-84fb-0541d2121f9b'
  ResourceConstants.LOGIN_ROOT = 'http://localhost:3000',
  ResourceConstants.CUSTOM_CLIENTS = {
    'z7a9zs6p7rzang': 'Drift Insider',
    '2s4izkwgch6v89': 'Drift Video',
    'yxb9v9kgtkn6wklocal': 'Bizops Admin'
  },
  ResourceConstants.DRIFT_VIDEO_CLIENT_ID = '2s4izkwgch6v89',
  ResourceConstants.DRIFT_VIDEO_CLIENT_ID_DRIFT = 'yxb9v9kgtkn6wklocal',
  ResourceConstants.DRIFT_VIDEO_URL = 'https://app-qa.video.drift.com'

}

ResourceConstants.DRIFFT_HOME_PAGE = 'https://www.drift.com'
ResourceConstants.APP_TITLE = 'Drift'
ResourceConstants.AUTH_COOKIE_NAME = 'DrifttAuth'
ResourceConstants.ORG_HANDLE_COOKIE_NAME = 'DrifttOrgHandle'
ResourceConstants.SEGMENTIO_WRITE_KEY = 'nwt3HcY5mRDsGViQWns9IWdlH49IoGLw'
ResourceConstants.GRANT_TYPE_PASSWORD = 'password'
ResourceConstants.ONE_TIME_TOKEN = 'driftt'
ResourceConstants.MICROSOFT_OAUTH_BASE_URL = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize'
ResourceConstants.VALID_PARTNERS = ['AppVault']


export default ResourceConstants



// WEBPACK FOOTER //
// ./src/constants/ResourceConstants.js